import { httpCreate } from './http';

const http = httpCreate('/srv/saas/wechat-msg');

export const wechatMsg = {
	startRemind(activityId) {
		return http.get(`/start-remind/${activityId}`);
	},
	// 校验模板提醒
	checkRemind(activityId) {
		return http.get(`/start-remind/${activityId}/check`);
	},
	// 校验订阅提醒
	checkSubscribeRemind(activityId) {
		return http.get(`/subscribe-remind/${activityId}/check`);
	},
};
